import React, { Component } from "react";
import Button from "../../Button/Button";
import Progress from "../Progress/Progress";
import BackNext from "../BackNext/BackNext";
import "./Form3.css";

class Form3 extends Component {
	// Initial signup form before onboarding
	render() {
		return (
			<div className="signup-form">
				<div className="signup-form-l container">
					<Progress
						onboardingStepBuyer={this.props.onboardingStepBuyer}
						onboardingFlowBuyer={this.props.onboardingFlowBuyer}
					/>
					<form onSubmit={e => this.props.nextOnboardingBuyer(e)}>
						<label>11. Your company's revenue (in M USD)  [optional]</label>
						<input type="text" placeholder="e.g. 1.5" value={this.props.signUpParamsBuyer['revenue']} onChange={e => this.props.onChangeInput('revenue', e.target.value, 'signUpParamsBuyer')}/>

						<label>12. Your company's total funding (in M USD)  [optional]</label>
						<input type="text" placeholder="e.g. 0.5" value={this.props.signUpParamsBuyer['funding']} onChange={e => this.props.onChangeInput('funding', e.target.value, 'signUpParamsBuyer')}/>
					
						<label>13. Estimated price you ask for (in M USD) [optional]</label>
						<input type="text" placeholder="e.g. 20" value={this.props.signUpParamsBuyer['price']} onChange={e => this.props.onChangeInput('price', e.target.value, 'signUpParamsBuyer')}/>
						
						<label>14. Potential buyers (ticker or url) on your mind [optional]</label>
						<label> Separate different potential buyers by ";"</label>
						<input type="text" placeholder="e.g. AAPL; SPGI; www.amazon.com" value={this.props.signUpParamsBuyer['neighbor']} onChange={e => this.props.onChangeInput('neighbor', e.target.value, 'signUpParamsBuyer')}/>
						
						<label>15. Potential buyer's businesses [optional]</label>
						<input type="text" placeholder="e.g. software; commercial bank" value={this.props.signUpParamsBuyer['buyer_business']} onChange={e => this.props.onChangeInput('buyer_business', e.target.value, 'signUpParamsBuyer')}/>
						
						<BackNext
							nextOnboardingBuyer={this.props.nextOnboardingBuyer}
							backOnboardingBuyer={this.props.backOnboardingBuyer}
							back={true}
							next={this.props.onboardingStepBuyer === 3 ? false : true}
						/>
					</form>
				</div>

			</div>
				
		);
	}
}

export default Form3;


// WEBPACK FOOTER //
// ./src/components/BuyerList/Form3/Form3.js